import { combineReducers } from 'redux';
import { loginReducer } from './login/reducer';
import uiReducer from './ui/reducer';

export const reducers = combineReducers({
  ui: uiReducer,
  login: loginReducer
});
